__turbopack_context__.v({
  "avatar": "D-ezFa_avatar",
  "blink": "D-ezFa_blink",
  "bot": "D-ezFa_bot",
  "brand": "D-ezFa_brand",
  "brandAvatar": "D-ezFa_brandAvatar",
  "brandName": "D-ezFa_brandName",
  "brandStatus": "D-ezFa_brandStatus",
  "brandText": "D-ezFa_brandText",
  "bubble": "D-ezFa_bubble",
  "chatBox": "D-ezFa_chatBox",
  "chatBtn": "D-ezFa_chatBtn",
  "closeButton": "D-ezFa_closeButton",
  "dot": "D-ezFa_dot",
  "floatIn": "D-ezFa_floatIn",
  "header": "D-ezFa_header",
  "history": "D-ezFa_history",
  "inputArea": "D-ezFa_inputArea",
  "message": "D-ezFa_message",
  "popIn": "D-ezFa_popIn",
  "prompts": "D-ezFa_prompts",
  "sendButton": "D-ezFa_sendButton",
  "statusDot": "D-ezFa_statusDot",
  "textInput": "D-ezFa_textInput",
  "typing": "D-ezFa_typing",
  "user": "D-ezFa_user",
});
